import Vue from 'vue';
import Locale from '@/locale/index';

const CONSTANT = Locale.en.constant;

const pleaseSelectOption = { value: null, text: 'Please select...' };

export const createListOptions = (constantName, nullOptionAsDefault = true) => {
  const defaultOption = nullOptionAsDefault ? [pleaseSelectOption] : [];
  if (!CONSTANT[constantName]) {
    return [defaultOption];
  }

  const options = Object.keys(CONSTANT[constantName]).map(key => ({
    value: key,
    text: Vue.i18n.t(`constant.${constantName}.${key}`),
  }));
  return [
    ...defaultOption,
    ...options,
  ];
};

export const funcMapToOptions = x => ({ value: x.id, text: x.lable });
export const parseFormOption = (vm, enumKey) => vm.invoiceListEnum[enumKey].map(funcMapToOptions);

export const setSelectValue = (options, searchValue) => {
  const matches = searchValue.match(/\d+/g);

  if (matches && matches.length > 1) {
    const searchNumber = matches[1];

    const matchedOption = options.find((option) => {
      const matchOption = option.value.match(/\d+/g);

      if (matchOption && matchOption.length > 1) {
        const optionNumber = matchOption[1];

        return option.value === searchValue.replace(searchNumber, optionNumber) ||
          (optionNumber === searchNumber && option.value === searchValue);
      }

      return false;
    });

    return matchedOption ? matchedOption.value : options[0].value;
  }

  return options[0].value;
};

export default {
  parseFormOption,
  createListOptions,
  setSelectValue,
};



// WEBPACK FOOTER //
// ./src/utils/select-options.js